module.exports = __webpack_public_path__ + "img/icon_win.71814797.png";